import React from "react";
import useObjectInput from "../../../hooks/useObjectInput";
import "./ErrorToast.css";

const ErrorDisplay = ({ error, isLast }) => (
  <div>
    <div className="error-toast-display-error">
      {error.rule && <p>{error.rule}:</p>}
      {error.ref && <p>{[error.ref]}</p>}
      {/* Display error.hint if error.ref exists, otherwise display error.hint in quotes */}
      {error.hint && <p>{error.ref ? error.hint : `"${error.hint}"`}</p>}
      {error.object && (
        <p>
          @<span>{error.object}</span>
        </p>
      )}
    </div>
    {isLast && <div className="error-toast-divider"></div>}
  </div>
);

const ErrorToast = () => {
  const { errorLog, changeShowErrorToast, handleSetShowErrors } =
    useObjectInput();

  const handleShowInErrorLog = () => {
    handleSetShowErrors(true);
    changeShowErrorToast(false);
  };

  return (
    <div className="error-toast-header-wrapper">
      <div className="error-toast-header">
        <span onClick={handleShowInErrorLog}>show in error log</span>
        <span onClick={() => changeShowErrorToast(false)}>close</span>
      </div>
      {errorLog.map((error, index) => (
        <ErrorDisplay
          key={index} // Replace with unique identifier
          error={error}
          isLast={
            error?.apiNo !== errorLog[index + 1]?.apiNo &&
            index < errorLog.length - 1
          }
        />
      ))}
    </div>
  );
};

export default ErrorToast;
